import { AccountSettings } from '../../../common/models/AccountSettings';

export class TableSettings {
  sortName: keyof AccountSettings;
  pageSizeName: keyof AccountSettings;
  constructor(sortName: keyof AccountSettings, pageSizeName: keyof AccountSettings) {
    this.sortName = sortName;
    this.pageSizeName = pageSizeName;
  }
}
